import React, { useState } from "react";
import { useNotify, useRedirect, useRefresh } from "react-admin";
import { Button, CircularProgress, Grid, Typography } from "@mui/material";
import moment from "moment";
import {
  cancelPendingPaymentSalvageBookingsLead,
  redirectToSB,
} from "../../../../../Utils/SalvageBookingsUtils";
import PropTypes from "prop-types";

const DepositPending = ({ sb }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const [loading, setLoading] = useState(false);
  const redirect = useRedirect();

  const handleButtonClick = async function () {
    if (!loading) {
      setLoading(true);
    }

    // Delete pending deposit payment in salvage bookings
    const responseStatus = await cancelPendingPaymentSalvageBookingsLead(
      sb.payments.deposit.id,
      sb.quote_request_id,
      "deposit"
    );

    if (responseStatus) {
      redirectToSB(sb.quote_request_id);
      setLoading(false);
    } else {
      setLoading(false);
      notify("Something went wrong, please try again", { type: "warning" });
    }
  };

  return (
    <React.Fragment>
      <Grid
        item
        xs={12}
        sx={{
          display: "flex",
          alignItems: "flex-start",
        }}
      >
        <Typography
          sx={{
            fontWeight: "700",
            letterSpacing: "0.46px",
            marginRight: "5px",
            textTransform: "uppercase",
          }}
        >
          Pending:
        </Typography>
        <Typography
          sx={{
            fontWeight: "700",
            letterSpacing: "0.46px",
            marginRight: "5px",
            textTransform: "capitalize",
          }}
        >
          {new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
          }).format(sb.payments.deposit.amount)}
        </Typography>
        {sb.payment && sb.payments.deposit.payment_paid && (
          <Typography
            sx={{
              fontWeight: "400",
              letterSpacing: "0.46px",
              textTransform: "capitalize",
            }}
          >
            {moment(sb.payments.deposit.payment_paid).format(
              "DD/MM/YYYY HH:mm"
            )}
          </Typography>
        )}
      </Grid>
      <Grid item xs={6}>
        <Button
          variant="contained"
          color="primary"
          label="Cancel Payment"
          fullWidth
          disabled={loading}
          onClick={handleButtonClick}
          sx={{
            border: "2px solid #FFF !important",
            backgroundColor: "#880000",
            color: "#FFF",
            height: "40px",
            fontWeight: "700",
            "&:hover": {
              backgroundColor: "#880000",
            },
          }}
        >
          Cancel Payment
        </Button>
        {loading && (
          <CircularProgress
            size={24}
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              marginTop: "-12px",
              marginLeft: "-12px",
            }}
          />
        )}
      </Grid>
    </React.Fragment>
  );
};

DepositPending.propTypes = {
  sb: PropTypes.object,
};

export default DepositPending;
